import React, { useRef, useState } from "react";
import {
  HeroCarousel,
  ServicesSection,
  CommunitiesSection,
  WhyCommunityApp,
  FeaturesQuickActions,
  RegisterCTA,
  FAQSection,
  HomeFooter,
} from "./components";
import { useRegRequests } from "../../hooks/useRegRequests";

const Home = () => {
  const registerFormRef = useRef(null);
  const [toastMsg, setToastMsg] = useState("");
  const { createRegRequest, loading, error } = useRegRequests();

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    const form = registerFormRef.current;
    if (!form) return;
    const data = Object.fromEntries(new FormData(form).entries());

    try {
      const { uid } = await createRegRequest(data);
      setToastMsg(
        `Thanks ${data.contactName}, we'll reach out to ${data.email}. (Ref: ${uid})`
      );
      form.reset();
    } catch {
      // error already set by the hook
    }
  };

  return (
    <>
      <main>
        <HeroCarousel />
        <ServicesSection />
        <CommunitiesSection />
        <WhyCommunityApp />
        <FeaturesQuickActions />
        <RegisterCTA
          onSubmit={handleRegisterSubmit}
          formRef={registerFormRef}
          toastMsg={toastMsg}
          submitting={loading} // optionally disable button in the component
        />
        {error && (
          <div className="container">
            <div className="alert alert-danger mt-3" role="alert">
              {error.message || "Something went wrong while submitting."}
            </div>
          </div>
        )}
        <FAQSection />
      </main>
      {/* <HomeFooter /> */}
    </>
  );
};

export default Home;